import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material'

import React, { useEffect, useState } from 'react'
import { ConsignmentUnit, docChargeheaderdata, documentsChargeType, handlekeyDown } from '../GSConstants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import EditIcon from '@mui/icons-material/Edit'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { focusElemnt, isEmpty, navigation3, sortTableData } from '../../../common/helper'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import Lineinput from '../../../common/lineinput'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import { connect } from 'react-redux'
import { getGSDocumentChargeInsertUpdate, getGSDocumentsCharge } from '../../../../store/generalSetting/GSAction'
import moment from 'moment'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import Modal from '../../../common/modal'
import LineInputV3 from '../../../common/lineInputV3'
import { useTranslation } from '../../../../i18n/I18nProvider'

const DocumentsChargeTab = (props) => {
  const { data, getGSDocumentsCharge, getGSDocumentChargeInsertUpdate, updateModal, updateAlertError } = props
  const { common, generalSettingReducer } = data
  const { gsDocumentsCharge } = generalSettingReducer
  const { loginData, showModal, modalType,companySettings } = { ...common }
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const [showTableData, setShowTableData] = useState([])
  const [tableData, setTableData] = useState([])
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('')
  const translatedDocChargeType = documentsChargeType.map((item) => ({ ...item, Name: tr(item.translationKey, item.Name) }))
  const translatedConsignmentUnit = ConsignmentUnit.map((item) => ({ ...item, Name: tr(item.translationKey, item.Name) }))
  const translatedDocHeaders = docChargeheaderdata.map((col) => ({
    ...col,
    headerName: tr(col.translationKey, col.headerName),
  }))
  const paymentModeOptions = (paymentModesWithAll || []).map((item) => {
    if (item.typeId === 0) {
      return { ...item, name: tr('gsAll', 'All') }
    }
    if (UseToPayAsCOD === 1) {
      if (item.typeId === 2) {
        return { ...item, name: tr('gsCod', 'COD') };
      }
      if (item.typeId === 7) {
        return { ...item, name: tr('gsCodManual', 'COD Manual') };
      }
      if (item.typeId === 9) {
        return { ...item, name: tr('gsCodDddv', 'COD DDDV') };
      }
      if (item.typeId === 4) {
        return null;
      }
    }
    return item;
  }).filter(Boolean)
  const [docChargeType, setDocChargeType] = useState(translatedDocChargeType[0])
  const [consiUnit, setConsiUnit] = useState(translatedConsignmentUnit[0])
  const [selPaymentType, setSelPaymentType] = useState(paymentModesWithAll[0])
  const [docChargeInputValue, setDocChargeInputValue] = useState('')
  const [manageFocus, setManageFocus] = useState(false)
  const [isActiveCheck, setIsActiveCheck] = useState()
  const [isUpdate, setIsUpdate] = useState(false)
  const [searchData, setSearchData] = useState({
    ChargeTypeDesc: '',
    BillingUnitDesc: '',
    PaymentType: '',
    DocumentCharge: '',
    ModifiedUser: '',
  })

  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  const newDocumentCharge = { id: 'CreateNewDocumentsCharge', lrListLabel: 'Create New Documents Charge popup modal', isSaved: false }

  useEffect(() => {
    setDocChargeType((prev) =>
      translatedDocChargeType.find((item) => item.id === prev?.id) || translatedDocChargeType[0]
    )
    setConsiUnit((prev) =>
      translatedConsignmentUnit.find((item) => item.id === prev?.id) || translatedConsignmentUnit[0]
    )
    setSelPaymentType((prev) =>
      prev?.typeId === 0 ? paymentModeOptions.find((item) => item.typeId === 0) || prev : prev
    )
  }, [translations])

  useEffect(() => {
    if (!isEmpty(gsDocumentsCharge)) {
      const updatedData = gsDocumentsCharge?.Table?.map((val) => ({ ...val, isEdit: false, DocumentsChargeV2: val.DocumentCharge, IsActiveV2: val.IsActive ,
        PaymentType:UseToPayAsCOD===1&&val.PayTypeID===2?tr('gsCod', 'COD'):val.PayTypeID===7?tr('gsCodManual', 'COD Manual'):val.PayTypeID===9?tr('gsCodDddv', 'COD DDDV'):val.PaymentType
      }))
      updatedData.sort((a, b) => {
        if (a.IsActive === b.IsActive) {
          return a.ModifiedUser.localeCompare(b.ModifiedUser)
        }
        return b.IsActive - a.IsActive
      })
      setShowTableData(updatedData)
      setTableData(updatedData)
    }
  }, [gsDocumentsCharge])
  useEffect(() => {
    focusElemnt('docChargeType')
  }, [])
  useEffect(() => {

    if (!isEmpty(loginData)) {
      const obj = {
        CompanyID: loginData?.intCompanyID,
        IsActive: -1
      }
      getGSDocumentsCharge(obj)
    }
  }, [loginData])
  useEffect(() => {
    let fiterData = tableData?.filter(
      (val) =>
        (searchData.ChargeTypeDesc === '' || val.ChargeTypeDesc.toLowerCase().includes(searchData.ChargeTypeDesc.toLowerCase())) &&
        (searchData.BillingUnitDesc === '' || val.BillingUnitDesc.toString().includes(searchData.BillingUnitDesc.toString())) &&
        (searchData.PaymentType === '' || val.PaymentType.toLowerCase().includes(searchData.PaymentType.toLowerCase())) &&
        (searchData.DocumentCharge === '' || val.DocumentCharge.toString().includes(searchData.DocumentCharge.toString())) &&
        (searchData.ModifiedUser === '' || val.ModifiedUser.toLowerCase().includes(searchData.ModifiedUser.toLowerCase()))
    )
    setShowTableData(fiterData)
  }, [searchData])

  const handleDocumentCharge = (e) => {
    const regex = new RegExp('^[0-9\""]*$');
    if (regex.test(e.target.value)) {
      setDocChargeInputValue(Number(e.target.value))
    }
}

  const handleSearchData = (event, field) => {
    setSearchData({ ...searchData, [field]: event.target.value })
  }
  const sortData = (e, field, sortOrder, type) => {
    setOrder(sortOrder)
    setOrderBy(field)
    const sortedData = sortTableData(e, field, sortOrder, type, showTableData)
    setShowTableData(sortedData)
  }
  const clickUpdate = () => {
    if (docChargeInputValue == "" || docChargeInputValue == ' ') {
      updateAlertError({ show: true, msg: tr('fillDocumentsCharge', 'Fill Documents Charge'), nextId: '' })
    } else if (docChargeType == '' || docChargeType == ' ') {
      updateAlertError({ show: true, msg: tr('selectDocumentsChargeType', 'Select Documents Charge Type'), nextId: '' })
    } else if (consiUnit == '' || consiUnit == ' ') {
      updateAlertError({ show: true, msg: tr('selectConsignmentUnit', 'Select Consignment Unit'), nextId: '' })
    } else if (selPaymentType == '' || selPaymentType == ' ') {
      updateAlertError({ show: true, msg: tr('selectPaymentType', 'Select Payment Type'), nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData?.intCompanyID,
        UserID: loginData?.intUserID,
        BillingUnit: consiUnit?.id,
        PayTypeID: selPaymentType?.typeId == 0 ? '1,2,3,4,5,6,7,8,9,10' : selPaymentType?.typeId,
        documentcharge: Number(docChargeInputValue),
        IsActive: isActiveCheck ? 1 : 0,
        DocChargeType: docChargeType?.id,
      }
      getGSDocumentChargeInsertUpdate(obj)
        .then((res) => {
          if (res?.status == 'Success') {
            setIsUpdate(false)
            updateModal(true, "CreateNewDocumentsCharge")
          } else {
            // updateModal(false, "CreateNewConsignmentType");
            updateAlertError({ show: true, msg: res.Message, nextId: 'docChargeType' })
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
      // setDocChargeType('')
      // setConsiUnit('')
      // setSelPaymentType('')
      
    }


  }

  const handleEditSave = (item) => {
    setManageFocus(false)
    const obj = {
      CompanyID: loginData?.intCompanyID,
      UserID: loginData?.intUserID,
      BillingUnit: item.BillingUnit,
      PayTypeID: item.PayTypeID,
      documentcharge: Number(item.DocumentsChargeV2),
      IsActive: item.IsActiveV2,
      DocChargeType: item.ChargeTypeID,
    }

    getGSDocumentChargeInsertUpdate(obj)
      .then((res) => {
        if (res?.status == 'Success') {
          setIsUpdate(true)
          updateModal(true, "CreateNewDocumentsCharge")
        } else {
          // updateModal(false, "CreateNewConsignmentType");
          updateAlertError({ show: true, msg: res.Message, nextId: 'docChargeType' })
        }
      })
      .catch((err) => {
        console.log('Error:', err)
      })
      
  }

  const modalClose = () => {
    const obj = {
      CompanyID: loginData?.intCompanyID,
      IsActive: -1
    }
    getGSDocumentsCharge(obj)
    updateModal(false, 'CreateNewDocumentsCharge')
    setIsUpdate(false)
    focusElemnt('docChargeType')
    setDocChargeInputValue('')
  }

  const handleChange = (val, index) => {
    let updatedRows = [...showTableData]
    if (index >= 0 && index <= updatedRows.length) {
      // Update the GoodsValueTo property of the previous row (index)
      updatedRows[index].DocumentsChargeV2 = val
      // updatedRows[index - 1].GoodsValueTo = e.target.value - 1
      setShowTableData(updatedRows)
    }
  }

  const handleEdit = (index, item) => {
    let updatedRows = [...showTableData]
    if (index >= 0 && index <= updatedRows.length) {
      // Update the GoodsValueTo property of the previous row (index)
      updatedRows[index].isEdit = !updatedRows[index].isEdit
      updatedRows[index].DocumentsChargeV2 = item.DocumentCharge
      updatedRows[index].IsActiveV2 = item.IsActive
      // updatedRows[index - 1].GoodsValueTo = e.target.value - 1
      
      updatedRows[index].isEdit === false ? setManageFocus(false) : setManageFocus(true)
      setShowTableData(updatedRows)
    }
    focusElemnt(`docIditBtn-${index + 1}`)
  }
  const onChange = (item, index) => {
    setManageFocus(false)
    let updatedRows = [...showTableData]
    if (index >= 0 && index <= updatedRows.length) {
      updatedRows[index].IsActiveV2 = item.IsActiveV2 == 0 ? 1 : 0
      setShowTableData(updatedRows)
      setTimeout(() => {
        focusElemnt(`docCheckBox-${index}`)
      }, 0)
    }

  }
  const SuccessModal = () => {
    return (
      <>
        <Modal
          headTxt={tr('successModel', 'Success Model')}
          modalStyle={modalStyle}
          modalClass={'booking-popup'}
          width={'25%'}
          closeId={'closeButton'}
          updateModal={updateModal}
          sx={{ marginTop: '20px' }}
        >
          <Stack>
            <Box style={{ margin: '10px', fontSize: '17px' }}>
              {isUpdate ? <div> {tr('documentsChargeUpdated', 'Documents Charge Updated !')}</div> : <div> {tr('documentsChargeCreated', 'Documents Charge Created!')}</div>}
            </Box>
          </Stack>
          <Stack>
            <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
              <button
                id='okBtn'
                autoFocus={true}
                style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px' }}
                onClick={() => modalClose()}
              // onKeyDown={(e) => {navigation3(e, `docIditBtn-0`, 'docActiveCheckBox', () => {})}}
              >
                {tr('gsOk', 'Ok')}
              </button>
            </div>
          </Stack>
        </Modal>
      </>
    )
  }
  const handleEditReset=(index, item)=>{
    let updatedRows = [...showTableData]
    if (index >= 0 && index <= updatedRows.length) {
      // Update the GoodsValueTo property of the previous row (index)
      updatedRows[index].isEdit = !updatedRows[index].isEdit
      updatedRows[index].DocumentsChargeV2 = item.DocumentCharge
      updatedRows[index].IsActiveV2 = item.IsActive
      // updatedRows[index - 1].GoodsValueTo = e.target.value - 1
      
      updatedRows[index].isEdit === false ? setManageFocus(false) : setManageFocus(true)
      setShowTableData(updatedRows)
    }
    setTimeout(()=>{
      focusElemnt(`docIditBtn-${index + 1}`)
    },100)
  }

  const keyboardNavigation = (event, prevId, nextId) => {
    if (event.key === 'Escape') {
      focusElemnt(prevId)
    }
    if (event.key === 'Enter') {
      focusElemnt(nextId)
    }
  }
  const InsideRowContent = ({ index, item }) => {
    return (
      <TableRow key={index} style={{ height: '18px' }}>
        <TableCell style={{ fontSize: '12px', fontWeight: '400', color: '#444', padding: '0px 16px 0px 16px' }}>{index + 1}</TableCell>
        <TableCell style={{ fontSize: '12px', fontWeight: '400', color: '#444', padding: '0px 16px 0px 16px' }}>
          {item.ChargeTypeDesc}
        </TableCell>
        <TableCell style={{ fontSize: '12px', fontWeight: '400', color: '#444', padding: '0px 16px 0px 16px' }}>
          {item.BillingUnitDesc}
        </TableCell>
        <TableCell style={{ fontSize: '12px', fontWeight: '400', color: '#444', padding: '0px 16px 0px 16px' }}>
          {item.PaymentType}
        </TableCell>
        <TableCell style={{ fontSize: '12px', fontWeight: '400', color: '#444', textAlign: 'right', padding: '0px 16px 0px 16px' }}>
          <span style={{ fontSize: '11px' }} title={item.Sender}>
            {item.isEdit ? (
              <Item sx={{ width: '100%', padding: '0px' }}>
                <input
                  // disabled={true}
                  id={`docChargeEditInput-${index}`}
                  className="input--style"
                  // label={requiredLabelTxt(`Sender Name`)}
                  // type="text"
                  // name="sendName"
                  // autoFocus={true}
                  autoFocus={manageFocus}
                  value={item.DocumentsChargeV2}
                  onChange={(e) => handleChange(e.target.value, index)}
                  style={{
                    textAlign: 'right'
                  }}
                  onKeyDown={(e) => {
                    navigation3(e, `docCheckBox-${index}`, `docChargeEditInput-${index}`)
                  }}
                />
              </Item>
            ) : (
              <>{item.DocumentCharge}</>
            )}
          </span>
        </TableCell>
        <TableCell
          style={{
            minHeight: '36px',
            textAlign: 'left',
            fontSize: '12px',
            color: '#444',
            maxWidth: '106px',
            fontWeight: '400',
            padding: '0px 16px 0px 16px',
          }}
        >
          <Tooltip
            title={`${item.ModifiedUser} (${item.UserBranch})`}
            PopperProps={{
              sx: {
                '& .MuiTooltip-tooltip': {
                  backgroundColor: '#DAEDFE',
                  color: '#000',
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: 'center',
                  marginTop: '5px !important',
                  fontSize: '12px',
                },
              },
            }}
            placement="bottom-start"
          >
            <span
              onMouseOver={(e) => (e.currentTarget.style.color = '#0086FF')}
              onMouseOut={(e) => (e.currentTarget.style.color = '#444')}
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              {item.ModifiedUser}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', fontWeight: '400', color: '#444', padding: '0px 16px 0px 16px' }}>
          {moment(item.ModifiedDate).format('HH:mm, DD-MMM-YY')}
        </TableCell>
        <TableCell className="checkbox-ctrl" style={{ textAlign: 'left', padding: '0px 16px 0px 16px' }}>
          <Item className="checkbox-ctrl" style={{ width: '8%', padding: '0px', backgroundColor: 'transparent' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id={`docCheckBox-${index}`}
                  checked={item.IsActiveV2 == 1}
                  // checked={consignerCheck}
                  onChange={(e) => item.isEdit ? onChange(item, index) : ''}
                  sx={{ fontSize: '12px', backgroundColor: 'transparent !important' }}
                  onKeyDown={(e) => {
                    navigation3(e, `checkMark-${index}`, `docChargeEditInput-${index}`)
                  }}
                />
              }
              labelPlacement="end"
            />
          </Item>
        </TableCell>
        <TableCell style={{ padding: '0px 16px 0px 16px' }}>
          {item.isEdit ? (
            <>
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', cursor: 'pointer' }}>
                <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                  onKeyDown={(e) => { navigation3(e, `xMark-${index}`,`docCheckBox-${index}`, () => { handleEditSave(item)}) }}
                >
                  <CheckCircleOutlineRoundedIcon
                    style={{ color: '#4CAF50', height: '18px', width: '18px' }}
                    onClick={() => { handleEditSave(item); focusElemnt('okBtn') }}
                  />
                </span>
                <span
                  key={`xMark-${index}`}
                  tabIndex={0}
                  id={`xMark-${index}`}
                  onKeyDown={(e) => {navigation3(e, `docChargeEditInput-${index}`, `checkMark-${index}`, () => {handleEditReset(index, item);focusElemnt(`docIditBtn-${index + 1}`)})
                  }}
                >
                  <HighlightOffRoundedIcon
                    style={{ color: '#F44336', height: '18px', width: '18px' }}
                    onClick={() => handleEditReset(index, item)}
                  />
                </span>
              </div>
            </>
          ) : (
            <span
              id={`docIditBtn-${index}`}
              tabIndex={0}
              style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', paddingRight: '20px', cursor: 'pointer' }}
              onClick={() => handleEdit(index, item)}
              onKeyDown={(e) => {handlekeyDown(e,index === 0 ? `docAddBtn`:`docIditBtn-${index - 1}`,index==showTableData?.length-1?'docChargeType':`docIditBtn-${index + 1}`,`docIditBtn-${index}`,() => {handleEdit(index, item);focusElemnt(`docChargeEditInput-${index}`)})}}
            >
              <EditIcon sx={{ marginRight: '3px' }} />
              {tr('gsEdit', 'Edit')}
            </span>
          )}
        </TableCell>
      </TableRow>
    )
  }
  return (
    <>
      <Box style={{ padding: '16px 0px 0px 0px' }}>
        <Stack >
          <TableContainer
            className="scrollBlue"
            style={{ borderRadius: '10px 10px 0px 0px',height:'55vh', border: '1px solid #ddd', borderBottom: 'none' }}
          >
            <Table
              stickyHeader
              size="small"
              aria-label="a dense table"
            // sx={{'& .MuiTableCell-root': {padding: '8px 20px ',},width: '100%',}}
            >
              <TableHead style={{ position: `sticky`, top: `0`, zIndex: '2' }}>
                <TableRow>
                  {translatedDocHeaders.map((val, i) => {
                    return (
                      <TableCell
                        key={`TH-${i}`}
                        style={{
                          ...val.headerSx,
                          backgroundColor: '#DAEDFE',
                          height: '40px',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#444',
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{val.headerName}</span>
                          {val.allowSorting && (
                            <span className="SortingIcons">
                              <span
                                className={`up ${orderBy === val.field && order === 'asc' ? 'active' : ''}`}
                                onClick={(e) => sortData(e, val.field, 'asc', val.dataType)}
                              >
                                <FontAwesomeIcon size="lg" icon={faCaretUp} transform="shrink-2" />
                              </span>
                              <span
                                className={`down ${orderBy === val.field && order === 'desc' ? 'active' : ''}`}
                                onClick={(e) => sortData(e, val.field, 'desc', val.dataType)}
                              >
                                <FontAwesomeIcon size="lg" icon={faCaretDown} transform="shrink-2" />
                              </span>
                            </span>
                          )}
                        </div>
                      </TableCell>
                    )
                  })}
                </TableRow>
                <TableRow>
                  {translatedDocHeaders.map((item, index) =>
                    item.showfilter ? (
                      <TableCell key={`FTH-${index}`}>
                        <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between', height: '36px' }}>
                          <input
                            id={`contains-${index}`}
                            className="field"
                            name="cancelSearchInput"
                            style={{ width: '100%', height: '30px' }}
                            placeholder={tr('gsContains', 'Contains')}
                            onChange={(e) => handleSearchData(e, item.field)}
                            onKeyDown={(e) => keyboardNavigation(e, index==1?`contains-5` : `contains-${index - 1}`,index==5?`contains-1` : `contains-${index + 1}`)}
                          />
                          <FilterAltIcon style={{color:'#AAA'}}/>
                        </div>
                      </TableCell>
                    ) : (
                      <TableCell></TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              {showTableData?.length <= 0 ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={14}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          <span>{tr('noResultsRefineSearch', 'No results found. Please refine your search parameters and search again.')}</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </>
              ) : showTableData?.length > 0 ? (
                <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                  {showTableData?.map((item, index) => (
                    <InsideRowContent item={item} index={index} key={index} />
                  ))}
                </TableBody>
              ) : (
                ''
              )}
            </Table>
          </TableContainer>
        </Stack>
      </Box>
      <Box
        className="beachTransBottomSec"
        style={{
          display: 'flex',
          justifyContent:'space-between',
          width: '100%',
          gap: '16px',
          backgroundColor: '#F5FAFE',
          padding: '10px 20px 10px 60px',
          border: '1px solid #ddd',
          borderRadius: '0px 0px 10px 10px ',
        }}
      >
        {/* <Item sx={sx.itemsxGrow}> */}
          <DropDownOA
            key={`docChargeType-${language}-${docChargeType?.Name}`}
            id={'docChargeType'}
            label={tr('docChargeType', 'Doc. Charge Type')}
            data={translatedDocChargeType}
            dataKey={'Name'}
            idKey={'id'}
            defaultvalue={docChargeType?.Name || ''}
            // disabled={true}
            onSelect={(val) => setDocChargeType(val)}
            nextId={'docConsUnit'}
            prevId={`docIditBtn-${showTableData?.length-1}`}
            width="15%"
          />
        {/* </Item> */}
        {/* <Item sx={sx.itemsxGrow}> */}
          <DropDownOA
            key={`docConsUnit-${language}-${consiUnit?.Name}`}
            id={'docConsUnit'}
            label={tr('consignmentUnit', 'Consignment Unit')}
            data={translatedConsignmentUnit}
            dataKey={'Name'}
            idKey={'id'}
            defaultvalue={consiUnit?.Name || ''}
            // disabled={true}
            onSelect={(val) => setConsiUnit(val)}
            nextId={'docPayType'}
            prevId={'docChargeType'}
            width="15%"
          />
        {/* </Item> */}
        {/* <Item sx={sx.itemsx} style={{ backgroundColor: 'transparent' }}> */}
          <DropDownOA
            key={`docPayType-${language}-${selPaymentType?.name}`}
            id={'docPayType'}
            label={tr('gsPayType', 'Payment Type')}
            isObjArr={true}
            onSelect={(val) => {
              setSelPaymentType(val)
            }}
            // data={paymentModesWithAll || []}
            data={paymentModeOptions}
            dataKey={`name`}
            idKey={`typeId`}
            defaultvalue={selPaymentType?.name || ''}
            value={selPaymentType?.name || ''}
            nextId={'DocChargeInputField'}
            prevId={'docConsUnit'}
            width="15%"
          />
        {/* </Item> */}
        <Item sx={{ padding: '0px', backgroundColor: 'transparent', fontWeight: '700',width:"15%" }}>
          <div className={'input--wrapper inputLine'} style={{ width: '100%' }}>
            <Lineinput
              // disabled={true}
              id={'DocChargeInputField'}
              label={tr('docChrg', 'Doc. Chrg.')}
              value={docChargeInputValue}
              onChange={(e) => handleDocumentCharge(e)}
              sx={{ color: '#444', fontWeight: '500' }}
              onKeyDown={(e) => {
                navigation3(e, 'docActiveCheckBox', 'docPayType', (e) => setDocChargeInputValue(e.target.value))
              }}
            />
          </div>
        </Item>
        <Item sx={{ padding: '0px', color: '#444', backgroundColor: 'transparent',width:"15%" }}>
          <div className={'input--wrapper inputLine'} style={{ width: '100%', color: '#444', fontWeight: '400' }}>
            <LineInputV3
              disabled={true}
              value={loginData?.strUserName}
              sx={{ color: '#444', fontWeight: '500' }}
            />
          </div>
        </Item>
        <Item sx={{ padding: '0px', backgroundColor: 'transparent',width:"15%" }}>
          <div className={'input--wrapper inputLine'} style={{ width: '100%' }}>
            <LineInputV3
              disabled={true}
              value={moment(new Date()).format('HH:mm') + ', ' + moment(new Date()).format('DD-MMM-YY')}
              sx={{ color: '#444', fontWeight: '500' }}
            />
          </div>
        </Item>
        <Item
          className="checkbox-ctrl"
          style={{ width: '5%', padding: '0px', backgroundColor: 'transparent', fontSize: '14px', color: '#444' }}
        >
          <FormControlLabel
            value="end"
            control={
              <Checkbox
                id={'docActiveCheckBox'}
                checked={isActiveCheck}
                onChange={() => setIsActiveCheck(!isActiveCheck)}
                sx={{ fontSize: '14px',fontWeight:'500', backgroundColor: 'transparent !important', color: '#444' }}
                onKeyDown={(e) => {
                  navigation3(e, 'docAddBtn', 'DocChargeInputField', () => setIsActiveCheck(isActiveCheck))
                }}
              />
            }
            label={tr('gsActive', 'Active')}
            labelPlacement="end"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper" style={{ width: '5%' }}>
          <Button
            id="docAddBtn"
            variant="contained"
            className="valuationbtn gobtn-primary"
            onKeyDown={(e) => { navigation3(e, `docIditBtn-0`, 'docActiveCheckBox', () => { clickUpdate(); focusElemnt('okBtn') }) }}
            onClick={() => clickUpdate()}
          >
            {tr('addBtn', 'ADD')}
          </Button>
        </Item>
      </Box>
      {showModal && [newDocumentCharge.id].includes(modalType) && SuccessModal(newDocumentCharge.id)}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getGSDocumentsCharge, getGSDocumentChargeInsertUpdate, updateModal, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(DocumentsChargeTab)
